// TODO: the translation should be taken from backend, not from here
import i18n from '@/lang/i18n'

export const SHIPMENT_COREENTITY_VALUES = {
    SAMPLE: { code: 'SAMPLE', name: i18n.t('entities.shipment.coreEntities.sample'), bgColor: 'rgba(10,160,190,1)' },
    PORTION: { code: 'PORTION', name: i18n.t('entities.shipment.coreEntities.portion'), bgColor: '#66ccffff' },
    SUBPORTION: { code: 'SUBPORTION', name: i18n.t('entities.shipment.coreEntities.subportion'), bgColor: '#ccccffff' }
}

export const SHIPMENT_INVALID_VALUE = { key: 'INVALID', name: 'entities.shipment.coreEntities.invalid', bgColor: 'red', color: 'white' }
